import {SnackBarTypes} from "./types";

export default {
    data: null,
    type: SnackBarTypes.INFO,
    active: false,
}